<template>
    <section>
    <div class="container">
        <div class="my-md-5 my-3 text-center">
                <h1>Oh, what fun it is to make treats together</h1>
                <p>Whip up incredibly yummy and easy-to-make holiday treats everyone in the family will love to make and enjoy.</p>
           </div>
                <div class="Recipes-wrapper">
                    <div class="row">
                        <div class="col-md-4 mb-4" v-for="recipe in recipes" :key="recipe.id">
                            <div class="recipe-card card text-center border border-0 p-3">
                                <img :src="recipe.image" :alt="recipe.alt" class="card-img-top recipe-card-image" />
                                <div class="card-body">
                                    <h5 class="card-title recipe-card-title" v-html="recipe.title"></h5>
                                    <a href="#" class="btn-link btn recipe-card-btn" data-bs-toggle="modal"
                                        data-bs-target="#recipeDetailsModal" @click="selectRecipe(recipe)">View Recipe Details</a>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4 mb-4">
                            <div class="pack-shot-container d-flex align-items-center h-100">
                                <img src="https://snippcheck.blob.core.windows.net/files/WKKC_Fun_In_The_Making_2008933/images/PackShots.png" alt="Pack Shot" class="img-fluid pack-shot-image" />
                            </div>
                        </div>
                    </div>
                </div>
    </div>
    </section>
    <div class="modal fade recipe-details-modal" id="recipeDetailsModal" data-bs-backdrop="static"
        data-bs-keyboard="false" tabindex="-1" aria-labelledby="recipeDetailsModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-lg">
            <div class="modal-content">
                <div class="modal-header border border-0">
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <div class="text-center mb-4">
                    <img v-if="selectedRecipe" :src="selectedRecipe.image" :alt="selectedRecipe.alt"
                        class="img-fluid mb-4 recipe-details-image" />
                    <h1 v-if="selectedRecipe" class="modal-title fs-3 recipe-details-title" id="recipeDetailsModalLabel"
                        v-html="selectedRecipe.modal.title"></h1>
                    <p v-if="selectedRecipe" class="modal-title recipe-details-subtitle"  v-html="selectedRecipe.modal.subtitle"></p>
                    </div>
                    <div class="row">
                        <div class="col-md-5">
                            <p><strong>Ingredients</strong></p>
                           <div v-if="selectedRecipe" class="recipe-details-ingredients"
                                v-html="selectedRecipe.modal.ingredients"></div>
                        </div>
                        <div class="col-md-7">
                            <p><strong>Directions</strong></p>
                            <div v-if="selectedRecipe" class="recipe-details-directions"
                                v-html="selectedRecipe.modal.directions"></div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer border border-0 justify-content-center">
                    <button type="button" class="btn btn-link" data-bs-dismiss="modal">Close</button>
                </div>
            </div>
        </div>
    </div>
</template>
<script lang="js">
export default {
    name: 'Recipes',
    data() {
        return {
            recipes: [],
            selectedRecipe: null,
        };
    },
    mounted() {
        fetch('/locales/recipes.json')
            .then((res) => {
                if (!res.ok) throw new Error('Failed to load recipes.json');
                return res.json();
            })
            .then((data) => {
                this.recipes = data;
            })
            .catch((err) => {
                // keep console error for debugging; component still renders gracefully
                // eslint-disable-next-line no-console
                console.error('Error loading recipes.json', err);
            });
    },
    methods: {
        selectRecipe(recipe) {
            this.selectedRecipe = recipe;
        },
    },
};

</script>
<style scoped>
</style>